import React, { Component, Fragment } from 'react';
import { createBrowserHistory } from "history";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { preventLogout } from "../actions/getTokenActions";
import { getuserme } from "../actions/userActions";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class CheckRefresh extends Component {

    constructor (props) {
        super(props);
        this.state = {
          redirect: false,
          redirecturl: ""
        };
      }

    componentDidMount() {
        //const search = window.location.href.split('/') ;
        //console.log(search)
        this.setlastpath(this.props.apitoken);
        this.ckeckcookie(this.props.apitoken);  
    }

    

    setlastpath(apitoken){
        if (apitoken !== null){
        const customHistory = createBrowserHistory();
        let lastpath = cookies.get('path')
        //console.log(lastpath + "|" + customHistory.location.pathname)
       

       if (lastpath !== customHistory.location.pathname ){
            cookies.set('path', customHistory.location.pathname, { path: '/' });
            this.setState ({
                redirecturl: customHistory.location.pathname
              })
        }
     } else {
        this.setState ({
            redirecturl: cookies.get('path')
          }) 
     } 
    }

    ckeckcookie(apitoken){
        if (apitoken === null){
        //console.log("---> API TOKEN NULL");
        //const customHistory1 = createBrowserHistory();
        let checkcookie = cookies.get('token')
        //console.log("---> COOPIE Token" + checkcookie);
       
        if (checkcookie !== undefined){
           const checkuserme = this.props.getuserme(checkcookie)
          
           checkuserme.then (result => {
            if (result.id !== undefined){
                //console.log("Resultid->" + result.id)
                this.props.preventLogout(checkcookie)   
            }
        },function (err) {
            console.log("Fehler beim Refresh!");
        })
        
        }
       }
      }

    render () {

        //console.log(this.state)
        return (
            <Fragment>
            {this.state.redirect &&
            <p></p> 
            }    
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken:  state.gettocken.apitoken
  });


  const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getuserme: getuserme,
        preventLogout: preventLogout
        }, dispatch);
    }


export default connect(mapStateToProps,mapDispatchToProps)(CheckRefresh);
